import '../IdcGlobal.IBP.Web/js/Inapp-browser.js'